import { jsPDF } from "jspdf";
import { PROFILE, EXPERIENCE, COMPETENCIES, TECH_STACK } from "../data/content";

const FILE_NAME = "Barbara E Betancourt Resume.pdf";
const INK = [74, 51, 34];
const TERRA = [184, 98, 42];
const MUTED = [158, 123, 90];

function newDoc() {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  return doc;
}

function header(doc) {
  doc.setTextColor(...INK);
  doc.setFont("times", "normal");
  doc.setFontSize(26);
  doc.text(PROFILE.name, 54, 64);
  doc.setFont("courier", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...TERRA);
  doc.text(PROFILE.title.toUpperCase(), 54, 82);
  doc.setTextColor(...MUTED);
  doc.text(`${PROFILE.email}   |   ${PROFILE.phone}   |   ${PROFILE.location}`, 54, 96);
  doc.setDrawColor(232, 216, 200);
  doc.line(54, 108, 558, 108);
}

function sectionTitle(doc, label, y) {
  doc.setFont("courier", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...TERRA);
  doc.text(label.toUpperCase(), 54, y);
  doc.setDrawColor(232, 216, 200);
  doc.line(54 + label.length * 6 + 12, y - 3, 558, y - 3);
  return y + 16;
}

function wrap(doc, text, x, y, width, lh = 13) {
  const lines = doc.splitTextToSize(text, width);
  lines.forEach((l) => { doc.text(l, x, y); y += lh; });
  return y;
}

export function downloadRoleResume(role) {
  const doc = newDoc();
  header(doc);
  let y = 132;
  y = sectionTitle(doc, "Summary", y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...INK);
  const OPS_BIO = "Resourceful operations and executive support professional with extensive experience creating organized, high-functioning environments that drive executive success, team productivity, and exceptional employee experiences. Skilled across office operations, facilities coordination, vendor management, event planning, project management, and cross-functional coordination, with a track record of turning complexity into clarity. Known for proactively anticipating needs, building scalable systems, and diplomatically navigating challenges, all while creating welcoming, people-first spaces that balance operational excellence with hospitality. Seeking to bring this blend of strategic thinking and hands-on problem-solving to a mission-driven organization.";
  const isOpsOrEA = role === "Executive Assistant" || role === "Operations Director";
  const focus = role ? ` with focused strength as a ${role}` : "";
  const summary = isOpsOrEA ? OPS_BIO : `Senior Executive Assistant and Operations Professional${focus}. ${PROFILE.intro}`;
  y = wrap(doc, summary, 54, y, 504);
  y += 12;

  y = sectionTitle(doc, "Experience", y);
  const sorted = role
    ? [...EXPERIENCE].sort((a, b) => (b.roles.includes(role) ? 1 : 0) - (a.roles.includes(role) ? 1 : 0))
    : EXPERIENCE;
  sorted.forEach((job) => {
    if (y > 700) { doc.addPage(); y = 60; }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(...INK);
    doc.text(job.pdfCompany || job.company, 54, y);
    doc.setFont("courier", "normal");
    doc.setFontSize(9);
    doc.setTextColor(...MUTED);
    doc.text(job.dates, 558, y, { align: "right" });
    y += 14;
    doc.setFont("helvetica", "italic");
    doc.setFontSize(10);
    doc.setTextColor(...TERRA);
    doc.text(job.role, 54, y);
    y += 15;
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...INK);
    doc.setFontSize(10);
    job.bullets.forEach((b) => {
      if (y > 720) { doc.addPage(); y = 60; }
      doc.text("•", 58, y);
      y = wrap(doc, b, 70, y, 488);
    });
    y += 8;
  });

  if (y > 640) { doc.addPage(); y = 60; }
  y = sectionTitle(doc, "Core Competencies", y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...INK);
  y = wrap(doc, COMPETENCIES.join("  ·  "), 54, y, 504);
  y += 12;
  y = sectionTitle(doc, "Tools & Technology", y);
  y = wrap(doc, TECH_STACK.join("  ·  "), 54, y, 504);

  doc.save(role ? `Barbara E Betancourt Resume - ${role}.pdf` : FILE_NAME);
}

export function downloadTailoredResume(data, kind = "full") {
  const doc = newDoc();
  header(doc);
  let y = 132;
  if (kind === "summary") {
    const ts = data.targeted_summary || {};
    y = sectionTitle(doc, "Targeted Summary", y);
    if (ts.headline) {
      doc.setFont("times", "italic");
      doc.setFontSize(13);
      doc.setTextColor(...INK);
      y = wrap(doc, ts.headline, 54, y, 504, 16);
      y += 6;
    }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(...INK);
    y = wrap(doc, ts.summary || "", 54, y, 504);
    y += 14;
    y = sectionTitle(doc, "Highlights", y);
    (ts.highlights || []).forEach((h) => {
      doc.text("•", 58, y);
      y = wrap(doc, h, 70, y, 488);
    });
  } else {
    const fr = data.full_resume || {};
    y = sectionTitle(doc, "Summary", y);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(...INK);
    y = wrap(doc, fr.summary || "", 54, y, 504);
    y += 12;
    y = sectionTitle(doc, "Experience", y);
    (fr.experience || []).forEach((job) => {
      if (y > 700) { doc.addPage(); y = 60; }
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(...INK);
      doc.text(job.pdfCompany || job.company || "", 54, y);
      doc.setFont("courier", "normal");
      doc.setFontSize(9);
      doc.setTextColor(...MUTED);
      doc.text(job.dates || "", 558, y, { align: "right" });
      y += 14;
      doc.setFont("helvetica", "italic");
      doc.setFontSize(10);
      doc.setTextColor(...TERRA);
      doc.text(job.role || "", 54, y);
      y += 15;
      doc.setFont("helvetica", "normal");
      doc.setTextColor(...INK);
      doc.setFontSize(10);
      (job.bullets || []).forEach((b) => {
        if (y > 720) { doc.addPage(); y = 60; }
        doc.text("•", 58, y);
        y = wrap(doc, b, 70, y, 488);
      });
      y += 8;
    });
    if (fr.skills && fr.skills.length) {
      if (y > 660) { doc.addPage(); y = 60; }
      y = sectionTitle(doc, "Skills", y);
      y = wrap(doc, fr.skills.join("  ·  "), 54, y, 504);
    }
  }
  doc.save(kind === "summary" ? "Barbara E Betancourt Resume - 1-page Summary.pdf" : "Barbara E Betancourt Resume - Full.pdf");
}
